import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterDropdownContentListItem from './VeltCommentsSidebarV2FilterDropdownContentListItem/VeltCommentsSidebarV2FilterDropdownContentListItem';
import VeltCommentsSidebarV2FilterDropdownContentListCategory from './VeltCommentsSidebarV2FilterDropdownContentListCategory/VeltCommentsSidebarV2FilterDropdownContentListCategory';
var VeltCommentsSidebarV2FilterDropdownContentList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterDropdownContentList.Item = VeltCommentsSidebarV2FilterDropdownContentListItem;
VeltCommentsSidebarV2FilterDropdownContentList.Category = VeltCommentsSidebarV2FilterDropdownContentListCategory;
export default VeltCommentsSidebarV2FilterDropdownContentList;
